import { Injectable } from '@angular/core';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class TarifService {
  listeAllTarifs = [];
  valueExists: number = 1;
  private listImportedTarifs: any[] = [];
  currentDate = new Date();
  date_Debut = new Date('01-01-2020');
  date_Fin = new Date(
    this.currentDate.setDate(this.currentDate.getDate() + 365)
  );
  constructor(
    private generalService: GeneralService,
    private dateService: DateService
  ) {
    this.getAllListTarifs(this.date_Debut, this.date_Fin);
  }

  get ListImportedTarifs(): any[] {
    return this.listImportedTarifs;
  }
  readExcelFile(fileInput) {
    const file = fileInput.files[0];
    const reader = new FileReader();

    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      let data = reader.result;
      let workbook = XLSX.read(data, { type: 'array', cellDates: true });

      // Display the available sheet names
      const sheetNames = workbook.SheetNames;
      console.log('Available sheets:', sheetNames);

      let selectedSheet = prompt(
        `Please enter the name of the sheet you want to import:\n${sheetNames.join(
          '\n'
        )}`
      );

      if (!sheetNames.includes(selectedSheet)) {
        alert(`Sheet name "${selectedSheet}" is not valid. Please try again.`);
        return;
      }

      const sheet = workbook.Sheets[selectedSheet];
      let jsonData = XLSX.utils.sheet_to_json(sheet, {
        raw: false,
        dateNF: 'yyyy-mm-dd',
      });

      jsonData = jsonData.map((row) => {
        const filteredRow = {};
        Object.keys(row).forEach((key) => {
          if (!key.startsWith('__EMPTY')) {
            let value = row[key];
            if (value instanceof Date) {
              // Correct the date by adjusting for timezone differences if needed
              value = new Date(
                value.getTime() + value.getTimezoneOffset() * 60000
              );
              filteredRow[key] = value.toISOString().split('T')[0]; // Format as YYYY-MM-DD
            } else {
              filteredRow[key] = value;
            }
          }
        });
        return filteredRow;
      });

      console.log(jsonData);

      this.listImportedTarifs = jsonData;
    };
  }

  getAllListTarifs(dateDebParam, dateFinParam) {
    let param = '';
    if (dateDebParam && dateFinParam) {
      param =
        this.dateService.setFormatDateRechercheServer(dateDebParam) +
        ',' +
        this.dateService.setFormatDateRechercheServer(dateFinParam) +
        ',';
    }

    if (param)
      this.generalService
        .rechercheTable2('API_Tarif', param)
        .subscribe((res: any) => {
          console.log(res);
          this.listeAllTarifs = res;

          if (this.listeAllTarifs.length == 0) {
            this.generalService.dialogSuccess(
              'pas de tarifs disponible!',
              false
            );
          }
        });
  }

  checkTarifCodeExist(
    tarifCode: number,
    callback: (exists: number) => void
  ): void {
    this.generalService
      .rechercheTable2('tarifExist', tarifCode)
      .subscribe((res: any) => {
        this.valueExists = res[0].Tarif_Existe;
        callback(this.valueExists); // Invoke callback with the correct value
      });
  }

  getNextTarifCode(listTarif): string {
    // Extract TARIF_CODEs and convert them to numbers

    let codes = listTarif
      .filter((e) => e.Tarif_Code)
      .map((tarif: any) => parseInt(tarif.Tarif_Code, 10));

    if (codes.length == 0) {
      codes = [0];
    }

    // Find the maximum code
    let maxCode = Math.max(...codes);

    let newCode = maxCode + 1;

    while (codes.includes(newCode)) {
      newCode += 1;
    }

    return newCode.toString();
  }
}
